<template>
    <div class="mainpage">
        <div class="d-flex align-items-center mb-3">
            <i @click="backToList" class="pi pi-arrow-left cursor-pointer"></i>
            <p @click="backToList" class="mb-0 px-2 cursor-pointer">Back to list</p>
        </div>
        <div class="input-fields">
            <label class="mb-1" for="protocol">Protocol</label>
                <InputText disabled v-model="this.getLinkData.protocol"/>
        </div>
        <div class="input-fields">
            <label class="mb-1" for="static-url">Link name</label>
            <InputText disabled type="text" v-model="getLinkData.linkName" />
        </div>
        <div class="input-fields">
            <label class="mb-1" for="static-url">Long URL</label>
            <InputText disabled type="text" v-model="getLinkData.longurl" />
        </div>
        <div class="options">
            <p class="fw-bold">Short URL options</p>
            <div class="input-fields">
                <label class="mb-1" for="static-url">Short Url</label>
                <div class="d-flex align-items-center">
                    <InputText class="w-50" disabled type="text" v-model="shortUrl" />
                    <Button severity="secondary" v-tooltip.focus="'Copied!'" size="large" text rounded class="mx-1" icon="pi pi-copy" @click="copy" />
                </div>
            </div>
            <div class="shortCheck">
                <Checkbox disabled v-model="getLinkData.allowShort" :binary="true" />
                <p class="mb-0 mx-2"> Allow short url in messages. </p>
            </div>
        </div>
        <div class="d-flex justify-content-end mb-3">
            <!-- <Button class="gap" label="Download" /> -->
            <Calendar ref="searchCalendar" @date-select="dateSearch" v-model="date" showIcon  selectionMode="range" :manualInput="false" placeholder="Last 30 days" :maxDate="maxDate"/>
        </div>
        <div class="row-2 graphs">
            <div class="graph-heading">
                Click Trend
            </div>
            <Skeleton v-if="trendLoader" class="card-skeleton"></Skeleton>
            <div v-else class="card-skeleton">
                <ECharts :chartOptions="getClickTrend" />
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap row-3">
            <div class="type-graph-all">
                <div class="graph-top-bar">
                    <div class="graph-heading">
                        Geographic Click Distribution
                    </div>
                    <div class="toggle-graph">
                        <SelectButton @change="fetchDemographicAnalytics" v-model="demoType" :options="demoOptions" optionLabel="name" optionValue="value" aria-labelledby="basic" />
                    </div>
                </div>
                <div v-if="demoLoader" class="d-flex justify-content-center align-items-center skeleton-box">
                    <Skeleton shape="circle" size="15rem"></Skeleton>
                    <div>
                        <Skeleton  :key="n" v-for="n in 6" class="skeleton-line-spacing"></Skeleton>
                    </div>
                </div>
                <div v-else-if="getEmptyState.demograph" class="d-flex justify-content-center align-items-center empty-graph">
                    No data available
                </div>
                <ECharts v-else :chartOptions="getDemographicClicks" />
            </div>
            <div class="type-graph-all">
                <div class="graph-top-bar">
                    <div class="graph-heading mb-4">
                        Telco Click Distribution
                    </div>
                </div>
                <div v-if="telcoLoader" class="d-flex justify-content-center align-items-center skeleton-box">
                    <Skeleton shape="circle" size="15rem"></Skeleton>
                    <div>
                        <Skeleton :key="n" v-for="n in 6" class="skeleton-line-spacing"></Skeleton>
                    </div>
                </div>
                <div v-else-if="getEmptyState.telco" class="d-flex justify-content-center align-items-center empty-graph">
                    No data available
                </div>
                <ECharts v-else :chartOptions="getTelcoClicks" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import ECharts from '@/components/common/ECharts.vue'
import SelectButton from 'primevue/selectbutton'
import moment from 'moment'

export default {
    name: 'LinkReport',
    components: {
        ECharts, SelectButton
    },
    data () {
        return {
            maxDate: null,
            shortUrl: '',
            date: [],
            startDay: '',
            endDay: '',
            demoLoader: false,
            browserLoader: false,
            telcoLoader: false,
            deviceLoader: false,
            trendLoader: false,
            demoType: 'city',
            demoOptions: [{ name: 'City', value: 'city' }, { name: 'State', value: 'state' }, { name: 'Country', value: 'country' }],
            browserType: 'browser',
            browserOptions: [{ name: 'Browser', value: 'browser' }, { name: 'OS', value: 'os' }],
            deviceType: 'device',
            deviceOptions: [{ name: 'Device', value: 'device' }, { name: 'Device make', value: 'make' }]
        }
    },
    methods: {
        async dateSearch () {
            if (this.date[1] != null) {
                this.$refs.searchCalendar.overlayVisible = false
                this.demoType = 'city'
                this.browserType = 'browser'
                this.deviceType = 'device'
                this.fetchTelcoAnalytics()
                this.fetchClickTrendAnalytics()
                this.fetchDemographicAnalytics()
                this.fetchDeviceAnalytics()
                this.fetchBrowserAnalytics()
            }
        },
        async fetchClickTrendAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                id: this.$route.query.id,
                from: this.startDay,
                to: this.endDay
            }
            this.trendLoader = true
            await this.$store.dispatch('Links/Reports/fetchClickTrendAnalytics', data)
            this.trendLoader = false
        },
        async fetchDemographicAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                id: this.$route.query.id,
                from: this.startDay,
                to: this.endDay,
                type: this.demoType
            }
            this.demoLoader = true
            await this.$store.dispatch('Links/Reports/fetchTypeAnalytics', data)
            this.demoLoader = false
        },
        async fetchTelcoAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                id: this.$route.query.id,
                from: this.startDay,
                to: this.endDay,
                type: 'telco'
            }
            this.telcoLoader = true
            await this.$store.dispatch('Links/Reports/fetchTypeAnalytics', data)
            this.telcoLoader = false
        },
        async fetchBrowserAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                id: this.$route.query.id,
                from: this.startDay,
                to: this.endDay,
                type: this.browserType
            }
            this.browserLoader = true
            await this.$store.dispatch('Links/Reports/fetchTypeAnalytics', data)
            this.browserLoader = false
        },
        async fetchDeviceAnalytics () {
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                id: this.$route.query.id,
                from: this.startDay,
                to: this.endDay,
                type: this.deviceType
            }
            this.deviceLoader = true
            await this.$store.dispatch('Links/Reports/fetchTypeAnalytics', data)
            this.deviceLoader = false
        },
        unsecuredCopyToClipboard (text) {
            const textArea = document.createElement('textarea')
            textArea.value = text
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            try {
                document.execCommand('copy')
            } catch (err) {
            }
            document.body.removeChild(textArea)
        },
        async copy () {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(this.shortUrl)
            } else {
                this.unsecuredCopyToClipboard(this.shortUrl)
            }
        },
        backToList () {
            this.$router.push('/link')
        },

        async getLinkReport (id) {
            const data = {
                id
            }
            this.globalLoader = true
            const resp = await this.$store.dispatch('Links/Link/detail', data)
            this.globalLoader = false
            if (!resp.LinkID) {
                this.$router.push('/link')
            }
            if (this.getLinkData.shortURL) {
                this.shortUrl = this.getLinkData.shortURL
            } else {
                const finalBackHalf = this.getLinkData.backHalf ? this.getLinkData.backHalf : this.getLinkData.pathLength === 6 ? 'xxxxxx' : 'xxxxxxxx'
                this.shortUrl = this.getLinkData.protocol.toLowerCase() + '://' + this.getLinkData.domain + '/' + finalBackHalf
            }
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Links/Link', ['getLinkData']),
        ...mapGetters('Links/Reports', ['getClickTrend',
            'getDemographicClicks',
            'getTelcoClicks',
            'getDeviceClicks',
            'getBrowserClicks',
            'getEmptyState'])
    },
    async mounted () {
        this.maxDate = new Date()
        this.getLinkReport(this.$route.query.id)
        this.fetchTelcoAnalytics()
        this.fetchClickTrendAnalytics()
        this.fetchDemographicAnalytics()
        this.fetchDeviceAnalytics()
        this.fetchBrowserAnalytics()
    }
}

</script>

<style scoped>

</style>
